export default __webpack_public_path__ + "static/media/iphone-14-pro.e04b285c.jpg";